export default {
      id: "icon-info-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-info",
      toString: function () {
        return this.url;
      }
    }